import { ConfirmationDialog, FormattedText } from "client/Components";
import { useDataInputDialog } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

type UnlinkAnotherCredentialsConfirmationDialogProps = {
	credentialTypeName: string;
	configuredByOtherCredentialName: string;
	onConfirmation(): void;
	onCancellation(): void;
};

export const UnlinkAnotherCredentialsConfirmationDialog = (props: UnlinkAnotherCredentialsConfirmationDialogProps): ReactElement => {
	const {
		configuredByOtherCredentialName,
		credentialTypeName,
		onConfirmation,
		onCancellation
	} = props;

	return (
		<ConfirmationDialog
			title={
				<FormattedText
					text={localize("_AnotherCredentialsSetIsUsedForLinkName")}
					thingsToReplace={[
						{ what: "{LinkName}", filler: credentialTypeName }
					]}
				/>
			}
			confirmText={localize("_Ok")}
			onConfirmation={onConfirmation}
			onCancellation={onCancellation}
			trackingId="unlink-another-credentials-confirmation-dialog"
		>
			<FormattedText
				text={localize("_TheFollowingCredentialsAreUsedForLinkName")}
				thingsToReplace={[
					{ what: "{LinkName}", filler: credentialTypeName },
					{ what: "{OtherCredentialsName}", filler: <b>{configuredByOtherCredentialName}</b>}
				]}
			/>
		</ConfirmationDialog>
	);
};
UnlinkAnotherCredentialsConfirmationDialog.displayName = "UnlinkAnotherCredentialsConfirmationDialog";

export type UnlinkAnotherCredentialsConfirmationDialogInitialData = Omit<
	UnlinkAnotherCredentialsConfirmationDialogProps,
	"onConfirmation" | "onCancellation"
>;

export function useUnlinkAnotherCredentialsConfirmationDialog(): [
	element: ReactElement | null,
	open: (initialData: UnlinkAnotherCredentialsConfirmationDialogInitialData) => Promise<TryResult<void>>
] {
	return useDataInputDialog<UnlinkAnotherCredentialsConfirmationDialogInitialData, void>(
		(props, onClose, onSave) => (
			<UnlinkAnotherCredentialsConfirmationDialog
				{...props}
				onCancellation={onClose}
				onConfirmation={onSave}
			/>
		)
	);
}